import { FC, memo } from 'react';

import Link from 'next/link';

import { CityInfo } from '@type-def_iqfu/public/CityDetailData';

import { CompaniesPageQueryType } from 'src/iqfu/data/companiesPagesData';

import styles from './InternalLinksCommon.module.scss';

type Props = {
  cityInfo: CityInfo;
  queryTypeString: string;
  pageQueryType: CompaniesPageQueryType;
};

const InternalLinksCommon: FC<Props> = memo(({ cityInfo, queryTypeString, pageQueryType }) => {
  const isMajorCityWard = cityInfo.city_category === 'major_city_ward' && cityInfo.parent_major_city;
  const companySortPath = pageQueryType ? `/${pageQueryType}` : '';

  return (
    <>
      <div className={styles.internal_links_area}>
        <div className={styles.links_area_inner}>
          <Link
            href={
              isMajorCityWard
                ? `/companies/cities/${cityInfo.parent_major_city?.code}${companySortPath}`
                : `/companies/prefectures/${cityInfo.prefecture.code}${companySortPath}`
            }
            className={`${styles.internal_link_button} ${styles.internal_link_button_one_column}`}
          >
            【{isMajorCityWard ? cityInfo.parent_major_city?.name : cityInfo.prefecture.name}版】{queryTypeString}
            <br />
            おすすめの不動産屋さんランキングへ
          </Link>

          <div className={styles.internal_links_stacks}>
            <Link
              href={`/landhouses/cities/${cityInfo.city.code}`}
              prefetch={false}
              className={`${styles.internal_link_button} ${styles.internal_link_button_two_column}`}
            >
              {cityInfo.city.name}の土地戸建て
              <br />
              売却相場を調べる
            </Link>
            <Link
              href={`/mansions/cities/${cityInfo.city.code}`}
              prefetch={false}
              className={`${styles.internal_link_button} ${styles.internal_link_button_two_column}`}
            >
              {cityInfo.city.name}のマンション
              <br />
              売却相場を調べる
            </Link>
          </div>
        </div>
      </div>
    </>
  );
});

InternalLinksCommon.displayName = 'InternalLinksCommon';

export default InternalLinksCommon;
